export class WorkShop {

    name : string = '';
    tel : string = '';
    manager : string = '';
    address : string = '';
    id : string = null;

    getName(){
        return this.name;
    }

    getTel(){
        return this.tel;
    }

    getManager(){
        return this.manager;
    }

    getAddress(){
        return this.address;
    }

    getId(){
        return this.id;
    }


    setName(name: string){
        this.name = name;
    }

    setTel(tel: string){
        this.tel = tel;
    }

    setManager(manager: string){
        this.manager = manager;
    }

    setAddress(address: string){
        this.address = address;
    }

    setId(id: string){
        this.id = id;
    }
}